import { setDefaultEventParameters } from './firebase/analytics';

/**
 * Team members' visits are tagged `traffic_type: internal`, and the GA4 data
 * filter «Internal Traffic» drops them. IP rules alone miss home offices, VPNs
 * and changing addresses, so a browser where a staff account signed in stays
 * tagged, also after logout. GA4 reads the value from the config, so the very
 * first page_view of the next visit is tagged too.
 */
const STORAGE_KEY = 'bn_interner_traffic';

export const INTERNAL_TRAFFIC = { traffic_type: 'internal' } as const;

export function isInternalDevice(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

/** Tags this browser as internal, for the current visit and all later ones. */
export function markInternalDevice(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // Storage blocked: the current visit is still tagged below.
  }
  setDefaultEventParameters(INTERNAL_TRAFFIC);
}
